import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    color: '#FFFFFF',

    '& fieldset': {
      borderColor: '#FFFFFF',
    },

    '&:hover fieldset': {
      borderColor: '#FFFFFF',
    },

    '&.Mui-focused fieldset': {
      borderColor: '#FFFFFF',
    },

    '&.Mui-error fieldset': {
      borderColor: '#FF5C5C',
    },

    '& input': {
      padding: '16px 16px',
      color: '#FFFFFF',
      fontSize: '1rem',
    },

    '& input::placeholder': {
      color: '#FFFFFF',
      opacity: 1,
    },

    '& input:-webkit-autofill': {
      boxShadow: '0 0 0px 1000px #000 inset',
      WebkitTextFillColor: '#FFFFFF',
      borderRadius: '8px',
    },
  },

  '& .MuiInputLabel-root': {
    color: '#FFFFFF !important' ,
    transition: 'all 0.3s ease',
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#FFFFFF',
  },

  '& .MuiFormHelperText-root': {
    color: '#FFFFFF',
    fontSize: '0.875rem',
  },
}));

const WhiteInputField = ({ label, helperText, error, ...props }) => {
  return (
    <StyledTextField
      label={label}
      variant="outlined"
      helperText={helperText}
      error={error}
      fullWidth
      {...props}
    />
  );
};

export default WhiteInputField;
